export default "__VITE_ASSET__C$Or1ykI__"